module.exports = __webpack_public_path__ + "static/media/GoogleSans-Regular.413c599d.woff2";